import {environment} from '../environments/environment';

export const HOME                  = environment.home;
export const DOMAIN                = environment.url;
export const API_BASE              = environment.apiUrl;
export const API_MOBILE            = environment.mobileUrl;
export const API_SALES             = environment.salesServiceRest;
export const SALES_URL             = environment.salesUrl;
export const API_SALES_DATA       = `${environment.salesServiceData}`;
export const SYSTEM_VERSION        = environment.system_version;
export const PRODUCTION            = environment.production;
export const AMBIENT               = environment.name;
export const SALES_TOKEN_URL       = environment.salesTokenUrl;
export const SALES_CLIENT_ID       = environment.salesClientId;
export const SALES_CLIENT_SECRET   = environment.salesClientSecret;
export const SALES_USERNAME        = environment.salesUsername;
export const SALES_PASSWORD        = environment.salesPassword;
export const ID_PRICE_BOOK         = environment.idPriceBook;
export const PAGINA_PAGAMENTO      = environment.paginaPagamento;
export const SALES_DEV_BASE        = environment.salesBase;
export const AUTH_SALES_API        = environment.authSalesApi;
export const BASICO                = '05';
export const COMPLETO              = '08';
export const IDEAL                 = '11';
export const EXCLUSIVO             = '14';
export const REQUINTE              = '17';
export const PLUS                  = '28';
export const BLACK                 = '31';
export const BASICO_TRIPLO         = '80';
export const COMPLETO_TRIPLO       = '83';
export const IDEAL_TRIPLO          = '86';
export const EXCLUSIVO_TRIPLO      = '89';
export const REQUINTE_TRIPLO       = '92';
export const PLUS_TRIPLO           = '95';
export const BLACK_TRIPLO          = '98';
export const COUNT_DIARIAS_DEFAULT = 7;
export const COUNT_MAX_DIARIAS_DEFAULT = 28;
export const ALL_INCLUSIVE         = 'AL';
export const MEIA_PENSAO_ALMOCO    = 'MA';
export const MEIA_PENSAO_JANTAR    = 'MJ';
export const CAFE_MANHA            = 'NP';
export const PENSAO_COMPLETA       = 'PC';
export const MEIA_PENSAO           = 'MP';
export const FLAT                  = { id: 1, value: 'FLAT'};
export const RESORT                = { id: 2, value: 'RESORT'};
export const FAZENDA               = { id: 3, value: 'FAZENDA'};
export const POUSADA               = { id: 4, value: 'POUSADA'};
export const HOTEL                 = { id: 5, value: 'HOTEL'};

export const PRODUCTS = [
	{
		attributes: {
			type: 'PricebookEntry',
			url: '/services/data/v52.0/sobjects/PricebookEntry/01u87000000YtUtAAK'
		},
		Id: '01u87000000YtUtAAK',
		Product2Id: '01t87000000Ee2qAAC',
		UnitPrice: 279.72,
		'Preco_de_Lista_Mensal__c': 23.31,
		Product2: {
			attributes: {
				type: 'Product2',
				url: '/services/data/v52.0/sobjects/Product2/01t87000000Ee2qAAC'
			},
			Id: '01t87000000Ee2qAAC',
			Name: 'Básico Duplo'
		}
	},
	{
		attributes: {
			type: 'PricebookEntry',
			url: '/services/data/v52.0/sobjects/PricebookEntry/01u87000000YtV3AAK'
		},
		Id: '01u87000000YtV3AAK',
		Product2Id: '01t87000000Ee2rAAC',
		UnitPrice: 336.72,
		'Preco_de_Lista_Mensal__c': 28.06,
		Product2: {
			attributes: {
				type: 'Product2',
				url: '/services/data/v52.0/sobjects/Product2/01t87000000Ee2rAAC'
			},
			Id: '01t87000000Ee2rAAC',
			Name: 'Básico Triplo'
		}
	},
	{
		attributes: {
			type: 'PricebookEntry',
			url: '/services/data/v52.0/sobjects/PricebookEntry/01u87000000YtV8AAK'
		},
		Id: '01u87000000YtV8AAK',
		Product2Id: '01t87000000Ee32AAC',
		UnitPrice: 1821.51,
		'Preco_de_Lista_Mensal__c': 151.79,
		Product2: {
			attributes: {
				type: 'Product2',
				url: '/services/data/v52.0/sobjects/Product2/01t87000000Ee32AAC'
			},
			Id: '01t87000000Ee32AAC',
			Name: 'Black Duplo'
		}
	},
	{
		attributes: {
			type: 'PricebookEntry',
			url: '/services/data/v52.0/sobjects/PricebookEntry/01u87000000YtVDAA0'
		},
		Id: '01u87000000YtVDAA0',
		Product2Id: '01t87000000Ee33AAC',
		UnitPrice: 1921.41,
		'Preco_de_Lista_Mensal__c': 160.12,
		Product2: {
			attributes: {
				type: 'Product2',
				url: '/services/data/v52.0/sobjects/Product2/01t87000000Ee33AAC'
			},
			Id: '01t87000000Ee33AAC',
			Name: 'Black Triplo'
		}
	},
	{
		attributes: {
			type: 'PricebookEntry',
			url: '/services/data/v52.0/sobjects/PricebookEntry/01u87000000YtVIAA0'
		},
		Id: '01u87000000YtVIAA0',
		Product2Id: '01t87000000Ee2sAAC',
		UnitPrice: 456.21,
		'Preco_de_Lista_Mensal__c': 38.02,
		Product2: {
			attributes: {
				type: 'Product2',
				url: '/services/data/v52.0/sobjects/Product2/01t87000000Ee2sAAC'
			},
			Id: '01t87000000Ee2sAAC',
			Name: 'Completo Duplo'
		}
	},
	{
		attributes: {
			type: 'PricebookEntry',
			url: '/services/data/v52.0/sobjects/PricebookEntry/01u87000000YtVNAA0'
		},
		Id: '01u87000000YtVNAA0',
		Product2Id: '01t87000000Ee2tAAC',
		UnitPrice: 556.11,
		'Preco_de_Lista_Mensal__c': 46.34,
		Product2: {
			attributes: {
				type: 'Product2',
				url: '/services/data/v52.0/sobjects/Product2/01t87000000Ee2tAAC'
			},
			Id: '01t87000000Ee2tAAC',
			Name: 'Completo Triplo'
		}
	},
	{
		attributes: {
			type: 'PricebookEntry',
			url: '/services/data/v52.0/sobjects/PricebookEntry/01u87000000YtVXAA0'
		},
		Id: '01u87000000YtVXAA0',
		Product2Id: '01t87000000Ee2wAAC',
		UnitPrice: 855.81,
		'Preco_de_Lista_Mensal__c': 71.32,
		Product2: {
			attributes: {
				type: 'Product2',
				url: '/services/data/v52.0/sobjects/Product2/01t87000000Ee2wAAC'
			},
			Id: '01t87000000Ee2wAAC',
			Name: 'Exclusivo Duplo'
		}
	},
	{
		attributes: {
			type: 'PricebookEntry',
			url: '/services/data/v52.0/sobjects/PricebookEntry/01u87000000YtVcAAK'
		},
		Id: '01u87000000YtVcAAK',
		Product2Id: '01t87000000Ee2xAAC',
		UnitPrice: 955.71,
		'Preco_de_Lista_Mensal__c': 79.64,
		Product2: {
			attributes: {
				type: 'Product2',
				url: '/services/data/v52.0/sobjects/Product2/01t87000000Ee2xAAC'
			},
			Id: '01t87000000Ee2xAAC',
			Name: 'Exclusivo Triplo'
		}
	},
	{
		attributes: {
			type: 'PricebookEntry',
			url: '/services/data/v52.0/sobjects/PricebookEntry/01u87000000YtVhAAK'
		},
		Id: '01u87000000YtVhAAK',
		Product2Id: '01t87000000Ee2uAAC',
		UnitPrice: 656.01,
		'Preco_de_Lista_Mensal__c': 54.67,
		Product2: {
			attributes: {
				type: 'Product2',
				url: '/services/data/v52.0/sobjects/Product2/01t87000000Ee2uAAC'
			},
			Id: '01t87000000Ee2uAAC',
			Name: 'Ideal Duplo'
		}
	},
	{
		attributes: {
			type: 'PricebookEntry',
			url: '/services/data/v52.0/sobjects/PricebookEntry/01u87000000YtVmAAK'
		},
		Id: '01u87000000YtVmAAK',
		Product2Id: '01t87000000Ee2zAAC',
		UnitPrice: 1188.81,
		'Preco_de_Lista_Mensal__c': 99.07,
		Product2: {
			attributes: {
				type: 'Product2',
				url: '/services/data/v52.0/sobjects/Product2/01t87000000Ee2zAAC'
			},
			Id: '01t87000000Ee2zAAC',
			Name: 'Requinte Triplo'
		}
	},
	{
		attributes: {
			type: 'PricebookEntry',
			url: '/services/data/v52.0/sobjects/PricebookEntry/01u87000000YtVrAAK'
		},
		Id: '01u87000000YtVrAAK',
		Product2Id: '01t87000000Ee2vAAC',
		UnitPrice: 755.91,
		'Preco_de_Lista_Mensal__c': 62.99,
		Product2: {
			attributes: {
				type: 'Product2',
				url: '/services/data/v52.0/sobjects/Product2/01t87000000Ee2vAAC'
			},
			Id: '01t87000000Ee2vAAC',
			Name: 'Ideal Triplo'
		}
	},
	{
		attributes: {
			type: 'PricebookEntry',
			url: '/services/data/v52.0/sobjects/PricebookEntry/01u87000000YtVwAAK'
		},
		Id: '01u87000000YtVwAAK',
		Product2Id: '01t87000000Ee2yAAC',
		UnitPrice: 1088.91,
		'Preco_de_Lista_Mensal__c': 90.74,
		Product2: {
			attributes: {
				type: 'Product2',
				url: '/services/data/v52.0/sobjects/Product2/01t87000000Ee2yAAC'
			},
			Id: '01t87000000Ee2yAAC',
			Name: 'Requinte Duplo'
		}
	},
	{
		attributes: {
			type: 'PricebookEntry',
			url: '/services/data/v52.0/sobjects/PricebookEntry/01u87000000YtW1AAK'
		},
		Id: '01u87000000YtW1AAK',
		Product2Id: '01t87000000Ee31AAC',
		UnitPrice: 1421.91,
		'Preco_de_Lista_Mensal__c': 118.49,
		Product2: {
			attributes: {
				type: 'Product2',
				url: '/services/data/v52.0/sobjects/Product2/01t87000000Ee31AAC'
			},
			Id: '01t87000000Ee31AAC',
			Name: 'Plus Triplo'
		}
	},
	{
		attributes: {
			type: 'PricebookEntry',
			url: '/services/data/v52.0/sobjects/PricebookEntry/01u87000000YtW6AAK'
		},
		Id: '01u87000000YtW6AAK',
		Product2Id: '01t87000000Ee34AAC',
		UnitPrice: 0,
		'Preco_de_Lista_Mensal__c': 0,
		Product2: {
			attributes: {
				type: 'Product2',
				url: '/services/data/v52.0/sobjects/Product2/01t87000000Ee34AAC'
			},
			Id: '01t87000000Ee34AAC',
			Name: 'Taxa de Adesăo'
		}
	},
	{
		attributes: {
			type: 'PricebookEntry',
			url: '/services/data/v52.0/sobjects/PricebookEntry/01u87000000YtWBAA0'
		},
		Id: '01u87000000YtWBAA0',
		Product2Id: '01t87000000Ee30AAC',
		UnitPrice: 1322.01,
		'Preco_de_Lista_Mensal__c': 110.17,
		Product2: {
			attributes: {
				type: 'Product2',
				url: '/services/data/v52.0/sobjects/Product2/01t87000000Ee30AAC'
			},
			Id: '01t87000000Ee30AAC',
			Name: 'Plus Duplo'
		}
	}
]
